import { render, staticRenderFns } from "./atm9Rules.vue?vue&type=template&id=45fc732b&scoped=true"
var script = {}
import style0 from "./atm9Rules.vue?vue&type=style&index=0&id=45fc732b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fc732b",
  null
  
)

export default component.exports